import Model from './model.js';

export default class PaymentMethod extends Model {
	static _routeKey = 'payment-method';

	static _attributes = {
		name_on_card: '',
		address_line_1: '',
		address_line_2: '',
		town: '',
		postcode: '',
		exp_month: '',
		exp_year: ''
	}
}